import ApiService from './ApiService'

import HARDCODE from '../business-const/HardCode/HardCode'

import AuthService from './AuthService'



class ClienteExemploInfoclientService extends ApiService {

    constructor() {
        super(HARDCODE.apiClienteExemploInfoclient)
    }

    buscarByIdClienteExemploMandatorio(variaveisGlobais, idClienteExemplo) {

        let params = `idUsuario=${AuthService.obterUsuarioLogado(variaveisGlobais)}`

        params = `${params}&idClienteExemplo=${idClienteExemplo}`

        return this.get(variaveisGlobais,
            `${HARDCODE.apiClienteExemploInfoclientBuscarByIdClienteExemploMandatorio}/?${params}`, false)
    }
}

export default ClienteExemploInfoclientService